import { render, staticRenderFns } from "./menzhen-jilu.vue?vue&type=template&id=04a8cf7c"
import script from "./menzhen-jilu.vue?vue&type=script&lang=ts"
export * from "./menzhen-jilu.vue?vue&type=script&lang=ts"
import style0 from "./menzhen-jilu.vue?vue&type=style&index=0&id=04a8cf7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports